import { Flex, Icon, Text, useTheme } from "@repo/ui";
import type { AgentPause } from "../agentPause";

/**
 * Flags that an agent-run task has stopped on an error. Deliberately one line:
 * the error item directly above already says what to fix, and the Unassign
 * control sits directly below.
 */
export function AgentPauseBanner({ pause }: { pause: AgentPause }) {
	const theme = useTheme();

	return (
		<Flex
			gap="md"
			align="center"
			padding="md"
			style={{
				backgroundColor: theme.colors.amber3,
				borderRadius: theme.borderRadiuses.md,
				border: `1px solid ${theme.colors.amber7}`,
			}}
		>
			<Icon
				name={pause === "clinic" ? "TriangleAlert" : "Headset"}
				color="amber11"
				size="sm"
				shrink={0}
			/>
			<Text size="md" weight="medium" color="sand12" style={{ flex: 1 }}>
				{pause === "clinic"
					? "The agent is paused until the error above is resolved."
					: "The agent is paused until Skyway support resolves the error above."}
			</Text>
		</Flex>
	);
}
